import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import {BackendApiService} from '../services/backend-api.service';

import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService) { }
  
  isChecked = false;


  ngOnInit(): void {
    setTimeout(() => {
      let data = {
        userId :localStorage.getItem('userId')
      }
      this.backendApiService.getTheme(data).subscribe(response => {
        if(response['status'] == true){
          let themeVar = (response['data'] == "black") ? "assets/scss/dark-style.css" : "assets/scss/white-style.css";
          this.isChecked = (response['data'] == "black") ? true : false;
          $("#mode").attr("href", themeVar);
        }
      })
    }, 200);
  }

  logout(){
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("totalRoom");
    this.router.navigate(['/']);
  }

  changeTheme(theme){
    if(this.isChecked == true){
      $("#mode").attr("href", "assets/scss/dark-style.css");
    }else{
      $("#mode").attr("href", "assets/scss/white-style.css");
    }
    let data = {
      theme:(this.isChecked)?'black':'white',
      userId :localStorage.getItem('userId')
    }
    
    this.backendApiService.changeTheme(data).subscribe(response => {
    })
  }
}
